import React, { useState, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { axiosInstnace as Axios } from "../../util/util";
import { endPoints } from "../../config";
import Pagination from "../admin/common/Pagination";
import NoData from "../admin/common/NoData";
import ReactAudioPlayer from "react-audio-player";
import { history } from "../../history/history";

const NewModel = ({ isNewShowing, hide, close }) => {
  //Set initial state
  const [audioList, handleAudioManagementList] = useState([]);
  const [selectedAudios, setSelectedAudios] = useState([]);
  const [noDataClass, handleNoDataClass] = useState("none");
  const [dataClass, handleDataClass] = useState("none");
  const [count, handleCount] = useState(0);
  const [skip, handleSkip] = useState(0);
  var reactAudio = useRef(undefined);

  useEffect(() => {
    getAudioManagementList(0);
  }, []);

  //Fetching the audio management list
  const getAudioManagementList = async (skip, name) => {
    try {
      handleSkip(skip);
      const data = await Axios.get(endPoints.getPreviousAudioByUser, {
        params: {
          skip,
          userEmail: JSON.parse(localStorage.getItem("userInfo")).email,
          name,
        },
      });
      const result = data.data.data.data;
      
      if (result && result.length > 0) {
        handleAudioManagementList(result);
        handleNoDataClass("none");
        handleDataClass("");
        handleCount(data.data.data.count);
      } else if (result && result.length === 0 && name) {
        handleAudioManagementList(result);
        handleNoDataClass("none");
        handleDataClass("");
      } else if (result && result.length === 0 && !name) {
        handleNoDataClass("");
        handleDataClass("none");
      }
    } catch (error) {
      console.log(error);
    }
  };

  //searching the audio list
  const getSearch = (e) => {
    if (e.target.value.length > 0) {
      getAudioManagementList(0, e.target.value);
    } else {
      getAudioManagementList(0);
    }
  };
  const getPageItems = async (skip) => {
    await getAudioManagementList(skip);
  };

  const closePopup = () => {
    hide();
    handleCount(0);
    handleSkip(0);
  };
  const addRemoveAudios = async(e, audioDetail) => {
    let audiolistselected = selectedAudios
    if (e.target.checked) {
       audiolistselected.push(audioDetail)
        await setSelectedAudios(audiolistselected);
        setSelectedAudios(selectedAudios => [...selectedAudios, ...audioDetail])
    } else {
      setSelectedAudios(
        audiolistselected.filter((evt) => {
          return evt.fileName !== audioDetail.fileName;
        })
      );
    }
  };
  //Existing audio select function
  const showCampaigns = (audio) => {
    let nodes = document.querySelectorAll(`tr[data-id="${audio}"]`);
    nodes.forEach((e) => {
      if (e.hasAttribute("style")) {
        e.removeAttribute("style");
      } else {
        e.style.display = "none";
      }
    });
  };

  const handleExistingAudio = (event) => {
    event.preventDefault()
    let sizes = selectedAudios.map((e) => {
      return e.audioDuration;
    });
    sizes = [...new Set(Array.from(sizes))];
    if (sizes.length > 1) {
      toast.error("Please select the audios in same duration", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: false,
        hideProgressBar: true,
        toastId: "1",
      });
     return;
    }else{
      const fileName = selectedAudios[0].fileName;
      const audioLength = selectedAudios[0].audioLength;
      const audioDuration = selectedAudios[0].audioDuration;
      const fileSize = selectedAudios[0].fileSize;
      // localStorage.setItem("ExistingAudioUrl", fileName);
      // localStorage.setItem("ExistingFileUrl", audioDetail.audioUrlPath);
      localStorage.setItem("ExistingAudioLength", audioLength);
      localStorage.setItem("ExistingAudioDuration", audioDuration);
      localStorage.setItem("ExistingAudioFileSize", fileSize);
      localStorage.setItem("ExistingAudios", JSON.stringify(selectedAudios))
      setSelectedAudios([])
      closePopup();
  
    }
  };

  return isNewShowing ? (
    <div className="dashboardContainer remark-popup">
      <div className="modal-overlay">
        <div
          className="modal-wrapper existing-audio-popup"
          aria-modal
          aria-hidden
          role="dialog"
        >
          <form className="form-group">
            <div className="modal">
              <div className="modal-head-cross rate-modal">
                <button
                  type="button"
                  className="modal-close-button"
                  onClick={close}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="editNonFct-header modal-header">
                  <div className="running_cap_head">
                    <h2 className="camp_head">Audio List</h2>
                    <div className="camp_right">
                      <div className="search_name">
                        <span className="search_img">
                          <img src="../../assets/images/search.png" />
                        </span>
                        <input
                          type="text"
                          placeholder="Search here by Campaign Name"
                          onChange={getSearch}
                        />
                      </div>
                      {selectedAudios.length > 0 && (
                        <div className="create_camp_btn">
                          <button onClick={handleExistingAudio}>Add Audios</button>
                        </div>
                      )}
                    </div>
                  </div>
                  {/*<div class="row">
                                    <div class="col-md-6">
                                        <h4 className="popup-head rqst-head fct-head modal-title">Audio List</h4>
                                    </div>
                                    <div class="col-md-6">
                                        <div className="search_name">
                                            <span className="search_img"><img src="../../assets/images/search.png" /></span>
                                            <input type="text" placeholder="Search here by Campaign Name" onChange={getSearch}/>
                                        </div>
                                    </div>
                                </div>*/}
                </div>

                <div className="editNonFct-modal modal-body">
                  <div className="bg-white">
                    <div className="popupCampaign-container">
                      <div className="campaign-input master-inputs nonFct">
                        {/*<div className="input-tag signup-tag clearfix fct-input">
                                                    <label className="static-value">Remarks </label>
                                                    <input name="stationName" type="text" className="form-control" onChange={getRemarks}  />
                                                    <div className="create-camp nonfct-submit">
                                                        <button onClick={handleContactsUsRemarks}>SAVE CHANGES</button>
                                                    </div>
                                                </div>*/}
                        <div className="dashboard-content userListing-dashboard bg-white table-responsive">
                          <table
                            className={
                              audioList.length > 0
                                ? "table master-table contact_list"
                                : "table master-table contact_list none"
                            }
                          >
                            <thead>
                              <tr>
                                <th>Select</th>
                                <th>S.No</th>
                                <th>Audio File</th>
                                <th>Audio</th>
                                <th>Campaigns</th>
                              </tr>
                            </thead>
                            <tbody>
                              {audioList &&
                                audioList.map((a, i) => (
                                  <React.Fragment>
                                    <tr key={i}>
                                      <td>
                                        <input
                                          type="checkbox"
                                          onClick={(e) => addRemoveAudios(e, a)}
                                        />
                                      </td>
                                      <td>{i + 1}</td>
                                      <td>{a.fileName}</td>
                                      <td>
                                        <ReactAudioPlayer
                                          src={a.audioUrl}
                                          controls
                                          controlsList="nodownload"
                                          onLoadedMetadata={(audio) => {
                                            a.audioDuration = Math.floor(
                                              audio.target.duration
                                            );
                                          }}
                                        />
                                      </td>
                                      <td
                                        style={{
                                          textAlign: "center",
                                          cursor: "pointer",
                                        }}
                                        onClick={(e) => {
                                          showCampaigns(i);
                                        }}
                                      >
                                        {a.campaigns.length}
                                      </td>
                                    </tr>
                                    <tr style={{ display: "none" }} data-id={i}>
                                      <th></th>
                                      <th>S.No</th>
                                      <th>Campaign Id</th>
                                      <th>Campaign Name</th>
                                    </tr>
                                    {a.campaigns.map((campaigns, j) => {
                                      return (
                                        <tr
                                          style={{ display: "none" }}
                                          key={j}
                                          data-id={i}
                                        >
                                          <td></td>
                                          <td>{j + 1}</td>
                                          <td>{campaigns._id}</td>
                                          <td>{campaigns.name}</td>
                                        </tr>
                                      );
                                    })}
                                  </React.Fragment>
                                ))}
                            </tbody>
                          </table>
                          <div className="paginationTable">
                            {(skip > 0 || count >= 10) && (
                              <Pagination
                                getAllData={getPageItems}
                                limit={10}
                                totalRecords={count}
                              />
                            )}
                          </div>
                        </div>
                        {audioList.length === 0 ? <NoData /> : null}
                      </div>
                      {/*<div className="create-camp nonfct-submit">
                  <button onClick={handleContactsUsRemarks}>SAVE CHANGES</button>
                </div>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <ToastContainer />
    </div>
  ) : null;
};

export default NewModel;



// WEBPACK FOOTER //
// ./web/components/campaign/newModel.js